export default __webpack_public_path__ + "static/media/BuildingboxOpen.0d533dfa.png";